<p-blockUI [blocked]="blocked">
  <div id="center" class="blocked-div">
    <p-progressSpinner class="blocked-div-spinner" strokeWidth="6"></p-progressSpinner>
  </div>
</p-blockUI>

<table  aria-describedby="Processing table" id="processingTable2" class="hybridization">
  <tr id="processingTableHeader">
    <th>Load Beadchip</th>
    <th>Hybridization</th>
  </tr>
  <tr>
    <td rowspan="3" id="processingTableBody">
      <div class="col-12 parent ml-2 mb-1 mt-4">
        <div class="col-12 child ui-inputgroup input-group-384-equipment">
          <button pButton class="theme-button noHover labelButton1" type="button" label="Equipment"></button>
          <input pInputText id="scan-liquid-handler" (keydown.enter)="checkMachineBarcode('load384BeadChipLiquidHandler','scan-384-beadchip-1')"
            (focusout)="checkMachineBarcode('load384BeadChipLiquidHandler','scan-384-beadchip-1')" name="SearchPlate" [(ngModel)]="load384BeadChipLiquidHandler"/>
        </div>
      </div>

      <div class="col-12 parent ml-2 mb-1">
        <div class="col-8 child ui-inputgroup input-group-384-array">
          <button pButton class="theme-button noHover labelButton1" type="button" label="Array ID"></button>
          <input pInputText id="scan-384-beadchip-1" name="SearchPlate" (keydown.enter)="validateArrayIDForAxiom384()"
            (focusout)="validateArrayIDForAxiom384()" [(ngModel)]="axiom384Beadchip" placeholder="Scan Array" />
        </div>
      </div>
      
      <div class="col-12 parent ml-2 mb-1">
        <div class="col-8 child ui-inputgroup input-group-384-plate">
          <button pButton class="theme-button noHover labelButton1" type="button" label="Plate Q1"></button>
          <input pInputText id="scan-384-plate-1" name="SearchPlate" [(ngModel)]="axiom384PlateID1" 
            (focusout)="validatePlateForAxiom384(axiom384PlateID1,1)"  (keydown.enter)="validatePlateForAxiom384(axiom384PlateID1,1)" />
        </div>
      </div>
      
      <div class="col-12 parent ml-2 mb-1">
        <div class="col-8 child ui-inputgroup input-group-384-plate">
          <button pButton class="theme-button noHover labelButton1" type="button" label="Plate Q2"></button>
          <input pInputText id="scan-384-plate-2" name="SearchPlate" [(ngModel)]="axiom384PlateID2" 
            (focusout)="validatePlateForAxiom384(axiom384PlateID2,2)" (keydown.enter)="validatePlateForAxiom384(axiom384PlateID2,2)"/>
        </div>
      </div>
      
      <div class="col-12 parent ml-2 mb-1">
        <div class="col-8 child ui-inputgroup input-group-384-plate">
          <button pButton class="theme-button noHover labelButton1" type="button" label="Plate Q3"></button>
          <input pInputText id="scan-384-plate-3" name="SearchPlate" [(ngModel)]="axiom384PlateID3" 
            (focusout)="validatePlateForAxiom384(axiom384PlateID3,3)" (keydown.enter)="validatePlateForAxiom384(axiom384PlateID3,3)"/>
        </div>
      </div>
      
      <div class="col-12 parent ml-2 mb-1">
        <div class="col-8 child ui-inputgroup input-group-384-plate">
          <button pButton class="theme-button noHover labelButton1" type="button" label="Plate Q4"></button>
          <input pInputText id="scan-384-plate-4" name="SearchPlate" [(ngModel)]="axiom384PlateID4" 
            (focusout)="validatePlateForAxiom384(axiom384PlateID4,4)" (keydown.enter)="validatePlateForAxiom384(axiom384PlateID4,4)"/>
        </div>
      </div>
      
      <div class="col-12 flex parent ml-2 mb-1">
        <button pButton label="Create Array" class="buttonsRound startButton" id="create-array-button"
        [disabled]="disableLoadBeadchipButton()" (click)="validateAndConfirmPlateSelection()"></button>
      </div>

      <div class="col-12 flex parent ml-2 mb-1">
        <button pButton label="New Array" class="buttonsRound endButton" (click)="resetData()"></button>
      </div>
      
      <div class="col-12 flex parent ml-2 mb-1">
        <button pButton label="GeneTitan Workfile" (click)="actionGeneTitanWorkfile()"
          class="buttonsRound transferToChamberButton VioletButtons" [disabled]="disableGeneTitanWorkfile()"></button>
      </div>

      <div class="col-12 flex parent ml-2 mb-1"> 
        <button pButton label="Data Export Evaluation" class="buttonsRound transferToChamberButton VioletButtons"
        (click)="downloadDataExportEvaluationReports()" [disabled]="disableDataExportEvaluation()"></button>
      </div>
    </td>
    <td id="processingTableBody">
      <div class="col-12 flex parent" id="lot-div">
        <div class="col-9"></div>
        <div class="col-2 child">
          <button pButton label="LOT" (click)="showChemicalPopup(false, 'HYBRIDIZATION')"  class="buttonsRound1 downLoadButton" type="button" ></button>
        </div>
      </div>
      <div class="col-12 flex parent">
        <div class="col-6 child">
          <button pButton label="Start Hybridization" (click)="saveBeadChipStatus('HYBRIDIZATION_STARTED', 0, 'HYBRIDIZATION', '', 0)"
            class="buttonsRound startButton" [disabled]="disableButton(0, 'HYBRIDIZATION', '', 0)"></button>
        </div>
        <div class="col-1"></div>
        <div class="col-4 timeStamp" *ngIf="isValidProcessStep('HYBRIDIZATION')">
          {{getProcessStepStartTimestamp('HYBRIDIZATION') | date: 'dd.MM.yy HH:mm'}}
          <br /> {{getProcessStepStartPuid('HYBRIDIZATION')}}
        </div>
      </div>
      
      <div class="col-12 flex parent">
        <div class="col-6 child">
          <button pButton label="Incubate 48°C" (click)="saveBeadChipStatus('INCUBATE_48C',2, 'HYBRIDIZATION', 'INCUBATE_48C', 0)"
            class="buttonsRound transferToChamberButton VioletButtons" [disabled]="disableButton(2, 'HYBRIDIZATION', 'INCUBATE_48C', 0)">
          </button>
        </div>
        <div class="col-1"></div>
        <div class="col-4 action-timer-div" *ngIf="isValidProcessStepAction('HYBRIDIZATION')">
          <span class="action-timer-span">{{calculateRemainingTimeForAction('HYBRIDIZATION', 'INCUBATE_48C')}} </span>
        </div>
      </div>

      <div class="col-12 flex parent">
        <div class="col-6 child">
          <button pButton label="Wash & Stain Prep." (click)="saveBeadChipStatus('WASH_AND_STAIN_PREP',2, 'HYBRIDIZATION', 'WASH_AND_STAIN_PREP', 1)"
            class="buttonsRound transferToChamberButton VioletButtons" [disabled]="disableButton(2, 'HYBRIDIZATION', 'WASH_AND_STAIN_PREP', 1)">
          </button>
        </div>
        <div class="col-1"></div>
        <div class="col-4 timeStamp" *ngIf="isValidProcessStepActionPerformed('HYBRIDIZATION', 'WASH_AND_STAIN_PREP')">
            {{getProcessStepActionTimeStamp('HYBRIDIZATION', 'WASH_AND_STAIN_PREP') | date: 'dd.MM.yy HH:mm'}}
            <br /> {{getProcessStepActionPuid('HYBRIDIZATION', 'WASH_AND_STAIN_PREP')}}
        </div>
      </div>
      <div class="col-12 flex parent" id="hybridization-div">
        <div class="col-6 child">
          <button pButton label="Load GeneTitan" (click)="saveBeadChipStatus('WAITING_FOR_ANALYSIS',1, 'HYBRIDIZATION', 'GENE_TITAN_LOADED', 0)"
            class="buttonsRound endButton" id="CHbutton" [disabled]="disableButton(1, 'HYBRIDIZATION', '', 0)"></button>
        </div>
        <div class="col-1"></div>
        <div class="col-4 timeStamp" *ngIf="isValidProcessStep('HYBRIDIZATION')">
          {{getProcessStepEndTimestamp('HYBRIDIZATION') | date: 'dd.MM.yy HH:mm'}}
          <br /> {{getProcessStepEndPuid('HYBRIDIZATION')}}
        </div>
      </div>
    </td>
  </tr>
  <tr id="processingTableHeader">
    <td class="secondHeader">Result Handling</td>
  </tr>
  <tr>                  
    <td id="processingTableBody">
      <div class="col-12 flex parent mt-5 mb-5">
        <div class="col-6 child">
          <button pButton label="Resultfiles Sent" class="buttonsRound otherbutton" [disabled]="disableResultfilesSent()"></button>
        </div>
      </div>
    </td>
  </tr>
</table>

<p-dialog header="Chemicals" [(visible)]="showDialogue" [focusOnShow]="true" [modal]="true" [style.width]="'800px'" position="top" (onHide)="hideChemicalDialog(selectedBeadChipPlate)">
  <app-ma-chemicals-popup [selectedPlate]="selectedBeadChipPlate" [selectedProcessStep]="selectedProcessStep" [processStepChemicals]="processStepChemicals" [noChemicalEdit]="noChemicalEdit" 
    [multiChemicals]="multiChemicalEdit" [plateids]="chemicalsBeadChipids" [isPlate]="true" [dialogOpen]="showDialogue" (backButtonEmitter)="hideChemicalDialog($event)"></app-ma-chemicals-popup>
</p-dialog>

<p-dialog header="Start Hybridization" [(visible)]="popUpWithDifferentMachine" showEffect="fade" position="top" [modal]="true" [contentStyle]="{'max-height':'70vh'}" (onHide)="closeMultiUpdatePopup(false)">
  <div class="content-in-multi-update-popup row">
    <div class="col-12 flex">
      <table aria-describedby="View Plates" class="table">
        <tr>
          <div class="mt-3 mb-3">
            <span class="pop-up-header">Incubate at 48°C for 23.5 h.</span><br>
            <span class="pop-up-header">Plates count: {{multiUpdateBeadChipInfoList.length}}</span>
          </div>
        </tr>
        <tr>
          <input pInputText name="ovenId" class="input-text-padding" [(ngModel)]="multiLiquidHandler" (keydown.enter)="checkMachineBarcode('multiLiquidHandler','popUpWithDifferentMachine-popup-plateid')" 
            (focusout)="checkMachineBarcode('multiLiquidHandler', 'popUpWithDifferentMachine-popup-plateid')" id="popUpWithDifferentMachine-popup-machineid"  placeholder="Scan Oven-ID" />
          <input pInputText name="plateId" class="input-text-padding"  [(ngModel)]="enteredBeadChipId" id="popUpWithDifferentMachine-popup-plateid"
              (keydown.enter)="checkBeadChip()" placeholder="Scan Array Barcode" />
        </tr>
        <tr *ngFor="let beadChip of multiUpdateBeadChipInfoList; let i = index;">
          <input pInputText name="ovenId" class="input-text-padding" [value]="beadChip.liquidHandler"  id="ovenid" readonly />
          <input pInputText name="plateId" class="input-text-padding" [value]="beadChip.beadChipID"  id="plateid" readonly />
          <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteBeadChipFromMultiUpdateList(i,'popUpWithDifferentMachine-popup-plateid')"></button>        
        </tr>
      </table>
    </div>
    <div class="col-12 flex">
      <button pButton label="Incubation 48°C" (click)="startAxiomHybridization()" 
        class="buttonsRound multi_UpdateButton VioletButtons" [disabled]="multiUpdateBeadChipInfoList.length == 0">
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="Wash And Stain Preparation" [(visible)]="washAndStainPopUp" showEffect="fade" position="top" [modal]="true" [style]="{'max-width':'51vw'}" [contentStyle]="{'max-height':'70vh'}" (onHide)="closeMultiUpdatePopup(false)">
  <div class="content-in-multi-update-popup row">
    <div class="col-12" style="width: 99%;">
      <p-table [value]="washStainPrepEligibleArrays" selectionMode="mulitple" [(selection)]="washAndStainTableSelectedRows">
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 20%; text-align: center;">Nr. Arrays</th>
            <th style="width: 50%; text-align: center;">Start Time</th>
            <th style="width: 30%; text-align: center;">Oven-ID</th>
            <th style="width: 4rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-array let-rowIndex="rowIndex">
          <tr [pSelectableRow]="array" [pSelectableRowIndex]="rowIndex">
            <td class="normalBody pr-0">
              {{array.plateIDs.length }}
            </td>
            <td class="normalBody pr-0">
              {{array.startTime | date: 'dd.MM.yy HH:mm'}} {{array.puid}}
            </td>
            <td class="normalBody pr-0">
              {{array.liquidHandlers}}
            </td>
            <td>
              <p-tableCheckbox [value]="array"></p-tableCheckbox>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="col-12 flex">
      <table aria-describedby="View Plates" class="table mb-0">
        <tr>
          <td class="wash-stain-prep-td">
            <div class="mt-3 mb-3">
              <span class="pop-up-header">Prepare Stains</span>
            </div>
          </td>
          <td class="wash-stain-prep-td" colspan="2">
            <div class="mt-3 mb-3">
              <input class="checbox-style mr-2 ml-2 p-2" type="checkbox" [(ngModel)]="multiPrepareStainsCheckboxValue"
                [disabled]="multiPrepareStainsCheckboxValue" />
            </div>
          </td>
        </tr>
        <tr>
          <td class="wash-stain-prep-td">
            <div class="mt-3 mb-3">
              <span class="pop-up-header">Destatic stain trays, scan tray and lids before transfer</span>
            </div>
          </td>
          <td class="wash-stain-prep-td" colspan="2">
            <div class="mt-3">
              <input class="checbox-style mr-2 ml-2 p-2" type="checkbox" [(ngModel)]="multiDestaticStainsCheckboxValue"
                [disabled]="multiDestaticStainsCheckboxValue || !multiPrepareStainsCheckboxValue" />
            </div>
          </td>
        </tr>
        <tr>
          <td class="wash-stain-prep-td">
            <div class="mt-3">
              <span class="pop-up-header">Register Lot Numbers</span>
            </div>
          </td>
        </tr>
      </table>
    </div>
    <div class="col-12 flex mt-0">
      <p-tabView (onChange)="onTabChange($event)" [activeIndex]="index">
        <p-tabPanel header="Stabilization" [headerStyleClass]="getCSSClassForPanel(0)">
          <div class="col-12 flex row m-1 mt-2">
            <div class="col-6">
              <div class="ui-inputgroup">
                <button pButton class="theme-button noHover labelButton" type="button" label="Equipment" style="height: 30px;"></button>
                <input pInputText name="multi-update-machine-field" [(ngModel)]="stabilizationEquipment" [disabled]="!multiDestaticStainsCheckboxValue"
                  (focusout)="checkMachineBarcode('stabilizationEquipment','stabilization-chemical')" (keydown.enter)="checkMachineBarcode('stabilizationEquipment','stabilization-chemical')" size="12"
                  class="inputFields" />
              </div>
            </div>
            <div class="col-6">
              <div class="ui-inputgroup load-gene-titan-input-group">
                <button pButton class="theme-button noHover labelButton" type="button"label="Stabilization"></button>
                <input pInputText name="multi-update-chemical-lot-field" id="stabilization-chemical" [disabled]="!multiDestaticStainsCheckboxValue"
                  [(ngModel)]="stabilizationChemical" (keydown.enter)="validateLotValues('stabilization')" size="12" class="inputFields border-right" />
                <div></div>
              </div>
              <div class="ui-inputgroup load-gene-titan-input-group" *ngFor="let lot of stabilizationChemicalList; let index=index;">
                <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Stabilization"></button>
                <input pInputText size="12" name="lotId" [value]="lot" id="lotid" class="inputFields border-left" readonly />
                <button pButton icon="fa fa-times-circle" class="removePopInput chemicalInputClassRemoveButton" (click)="deleteLotValue('stabilization', index, 'stabilization-chemical')"></button>        
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Stain 1" [headerStyleClass]="getCSSClassForPanel(1)">
          <div class="col-12 flex row m-1 mt-2">
            <div class="col-6">
              <div class="ui-inputgroup">
                <button pButton class="theme-button noHover labelButton" type="button" label="Equipment" style="height: 30px;"></button>
                <input pInputText name="multi-update-machine-field" [(ngModel)]="stain1Equipment" [disabled]="!multiDestaticStainsCheckboxValue"
                (focusout)="checkMachineBarcode('stain1Equipment','stain1-chemical')" (keydown.enter)="checkMachineBarcode('stain1Equipment','stain1-chemical')" size="12"
                  class="inputFields" />
              </div>
            </div>
            <div class="col-6">
              <div class="ui-inputgroup load-gene-titan-input-group">
                <button pButton class="theme-button noHover labelButton" type="button"label="Stain1"></button>
                <input pInputText name="multi-update-chemical-lot-field" id="stain1-chemical" [disabled]="!multiDestaticStainsCheckboxValue"
                  [(ngModel)]="stain1Chemical" (keydown.enter)="validateLotValues('stain1')" size="12" class="inputFields border-right" />
                <div></div>
              </div>
              <div class="ui-inputgroup load-gene-titan-input-group" *ngFor="let lot of stain1ChemicalList; let index=index;">
                <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Stain1"></button>
                <input pInputText size="12" name="lotId" [value]="lot" id="lotid" class="inputFields border-left" readonly />
                <button pButton icon="fa fa-times-circle" class="removePopInput chemicalInputClassRemoveButton" (click)="deleteLotValue('stain1', index, 'stain1-chemical')"></button>        
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Stain 2" [headerStyleClass]="getCSSClassForPanel(2)">
          <div class="col-12 flex row m-1 mt-2">
            <div class="col-6">
              <div class="ui-inputgroup">
                <button pButton class="theme-button noHover labelButton" type="button" label="Equipment" style="height: 30px;"></button>
                <input pInputText name="multi-update-machine-field" [(ngModel)]="stain2Equipment" [disabled]="!multiDestaticStainsCheckboxValue"
                (focusout)="checkMachineBarcode('stain2Equipment','stain2-chemical')" (keydown.enter)="checkMachineBarcode('stain2Equipment','stain2-chemical')" size="12"
                  class="inputFields" />
              </div>
            </div>
            <div class="col-6">
              <div class="ui-inputgroup load-gene-titan-input-group">
                <button pButton class="theme-button noHover labelButton" type="button"label="Stain2"></button>
                <input pInputText name="multi-update-chemical-lot-field" id="stain2-chemical" [disabled]="!multiDestaticStainsCheckboxValue"
                  [(ngModel)]="stain2Chemical" (keydown.enter)="validateLotValues('stain2')" size="12" class="inputFields border-right" />
                <div></div>
              </div>
              <div class="ui-inputgroup load-gene-titan-input-group" *ngFor="let lot of stain2ChemicalList; let index=index;">
                <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Stain2"></button>
                <input pInputText size="12" name="lotId" [value]="lot" id="lotid" class="inputFields border-left" readonly />
                <button pButton icon="fa fa-times-circle" class="removePopInput chemicalInputClassRemoveButton" (click)="deleteLotValue('stain2', index, 'stain2-chemical')"></button>        
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Ligation" [headerStyleClass]="getCSSClassForPanel(3)">
          <div class="col-12 flex row m-1 mt-2">
            <div class="col-6">
              <div class="ui-inputgroup">
                <button pButton class="theme-button noHover labelButton" type="button" label="Equipment" style="height: 30px;"></button>
                <input pInputText name="multi-update-machine-field" [(ngModel)]="ligationEquipment" [disabled]="!multiDestaticStainsCheckboxValue"
                (focusout)="checkMachineBarcode('ligationEquipment','ligation-chemical')" (keydown.enter)="checkMachineBarcode('ligationEquipment','ligation-chemical')" size="12"
                  class="inputFields" />
              </div>
            </div>
            <div class="col-6">
              <div class="ui-inputgroup load-gene-titan-input-group">
                <button pButton class="theme-button noHover labelButton" type="button"label="Ligation"></button>
                <input pInputText name="multi-update-chemical-lot-field" id="ligation-chemical" [disabled]="!multiDestaticStainsCheckboxValue"
                  [(ngModel)]="ligationChemical" (keydown.enter)="validateLotValues('ligation')" size="12" class="inputFields border-right" />
                <div></div>
              </div>
              <div class="ui-inputgroup load-gene-titan-input-group" *ngFor="let lot of ligationChemicalList; let index=index;">
                <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Ligation"></button>
                <input pInputText size="12" name="lotId" [value]="lot" id="lotid" class="inputFields border-left" readonly />
                <button pButton icon="fa fa-times-circle" class="removePopInput chemicalInputClassRemoveButton" (click)="deleteLotValue('ligation', index, 'ligation-chemical')"></button>        
              </div>
            </div>
          </div>
        </p-tabPanel>
        <p-tabPanel header="Hold Buffer" [headerStyleClass]="getCSSClassForPanel(4)">
          <div class="col-12 flex row m-1 mt-2">
            <div class="col-6">
              <div class="ui-inputgroup">
                <button pButton class="theme-button noHover labelButton" type="button" label="Equipment" style="height: 30px;"></button>
                <input pInputText name="multi-update-machine-field" [(ngModel)]="holdBufferEquipment" [disabled]="!multiDestaticStainsCheckboxValue"
                (focusout)="checkMachineBarcode('holdBufferEquipment','hold-buffer-chemical')" (keydown.enter)="checkMachineBarcode('holdBufferEquipment','hold-buffer-chemical')" size="12"
                  class="inputFields" />
              </div>
            </div>
            <div class="col-6">
              <div class="ui-inputgroup load-gene-titan-input-group">
                <button pButton class="theme-button noHover labelButton" type="button"label="Hold Buffer"></button>
                  <input pInputText name="multi-update-chemical-lot-field" id="hold-buffer-chemical" [disabled]="!multiDestaticStainsCheckboxValue"
                    [(ngModel)]="holdBufferChemical" (keydown.enter)="validateLotValues('holdBuffer')" size="12" class="inputFields border-right" />
                  <div></div>
                </div>
                <div class="ui-inputgroup load-gene-titan-input-group" *ngFor="let lot of holdBufferChemicalList; let index=index;">
                  <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Hold Buffer"></button>
                  <input pInputText size="12" name="lotId" [value]="lot" id="lotid" class="inputFields border-left" readonly />
                  <button pButton icon="fa fa-times-circle" class="removePopInput chemicalInputClassRemoveButton" (click)="deleteLotValue('holdBuffer', index, 'hold-buffer-chemical')"></button>        
                </div>
              </div>
          </div>
        </p-tabPanel>
      </p-tabView>
    </div>
    <div class="col-12 flex">
      <button pButton label="Wash & Stain Prep" (click)="completeWashAndStainPreparation()" 
        class="buttonsRound multi_UpdateButton VioletButtons" [disabled]="disableWashAndStainPrepButton()">
      </button>
    </div>
  </div>
</p-dialog>

<p-dialog header="GeneTitan Loaded" [(visible)]="popUpWithDifferentMachineAndChemicals" showEffect="fade" position="top" [modal]="true" [style]="{'width':'65vw'}" [contentStyle]="{'max-height':'70vh'}" (onHide)="closeMultiUpdatePopup(false)">
  <div class="content-in-multi-update-popup row">
    <div class="col-6">
      <table aria-describedby="View Plates" class="table">
        <tr>
          <div class="mt-3 mb-3">
            <span class="pop-up-header">Load Array onto GeneTitan</span><br>
            <span class="pop-up-header">Plates count: {{multiUpdateBeadChipInfoList.length}}</span>
          </div>
        </tr>
        <tr>
          <input pInputText class="input-text-padding" name="ovenId" [(ngModel)]="multiLiquidHandler" (keydown.enter)="checkMachineBarcode('multiLiquidHandler','popUpWithDifferentMachineAndChemicals-popup-plateid')" 
            (focusout)="checkMachineBarcode('multiLiquidHandler', 'popUpWithDifferentMachineAndChemicals-popup-plateid')" id="popUpWithDifferentMachineAndChemicals-popup-machineid"  placeholder="Scan GeneTitan" />
          <input pInputText class="input-text-padding" name="plateId" [(ngModel)]="enteredBeadChipId" id="popUpWithDifferentMachineAndChemicals-popup-plateid"
              (keydown.enter)="checkBeadChip()" placeholder="Scan Array Barcode" />
        </tr>
        <tr *ngFor="let beadChip of multiUpdateBeadChipInfoList; let i = index;">
          <input pInputText class="input-text-padding" name="ovenId" [(ngModel)]="beadChip.liquidHandler"  id="ovenid" readonly />
          <input pInputText class="input-text-padding" name="plateId" [(ngModel)]="beadChip.beadChipID"  id="plateid" readonly />
          <button pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteBeadChipFromMultiUpdateList(i,'popUpWithDifferentMachineAndChemicals-popup-plateid')"></button>        
        </tr>
      </table>
    </div>
    <div class="col-6">
      <table aria-describedby="View Plates" class="table">
        <tr>
          <div class="ui-inputgroup load-gene-titan-input-group mt-5">
            <button pButton class="theme-button noHover labelButton" type="button"label="Wash A"></button>
            <input pInputText name="multi-update-chemical-lot-field" id="washA-chemical"
              [(ngModel)]="washAChemical" (keydown.enter)="validateLotValues('washA')" size="12" class="inputFields border-right" />
          </div>
          <div class="ui-inputgroup load-gene-titan-input-group " *ngFor="let lot of washAChemicalList; let index=index;">
            <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Wash A"></button>
            <input pInputText size="12" name="lotId" [value]="lot" id="lotid" class="inputFields border-left" readonly />
            <button pButton icon="fa fa-times-circle" class="removePopInput chemicalInputClassRemoveButton" (click)="deleteLotValue('washA', index, 'washA-chemical')"></button>
          </div>
        </tr>
        <tr>
          <div class="ui-inputgroup load-gene-titan-input-group mt-2">
            <button pButton class="theme-button noHover labelButton" type="button"label="Wash B"></button>
            <input pInputText name="multi-update-chemical-lot-field" id="washB-chemical"
              [(ngModel)]="washBChemical" (keydown.enter)="validateLotValues('washB')" size="12" class="inputFields border-right" />
          </div>
          <div class="ui-inputgroup load-gene-titan-input-group " *ngFor="let lot of washBChemicalList; let index=index;">
            <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Wash B"></button>
            <input pInputText size="12" name="lotId" [value]="lot" id="lotid" class="inputFields border-left" readonly />
            <button pButton icon="fa fa-times-circle" class="removePopInput chemicalInputClassRemoveButton" (click)="deleteLotValue('washB', index, 'washB-chemical')"></button>
          </div>
        </tr>
        <tr>
          <div class="ui-inputgroup load-gene-titan-input-group mt-2">
            <button pButton class="theme-button noHover labelButton" type="button"label="Axiom Water"></button>
            <input pInputText name="multi-update-chemical-lot-field" id="axiom-water-chemical"
              [(ngModel)]="axiomWaterChemical" (keydown.enter)="validateLotValues('axiomWater')" size="12" class="inputFields border-right" />
          </div>
          <div class="ui-inputgroup load-gene-titan-input-group " *ngFor="let lot of axiomWaterChemicalList; let index=index;">
            <button pButton class="theme-button noHover labelButton hiddenLabelButton" type="button" label="Axiom Water"></button>
            <input pInputText size="12" name="lotId" [value]="lot" id="lotid" class="inputFields border-left" readonly />
            <button pButton icon="fa fa-times-circle" class="removePopInput chemicalInputClassRemoveButton" (click)="deleteLotValue('axiomWater', index, 'axiom-water-chemical')"></button>
          </div>
        </tr>
      </table>
    </div>
    <div class="col-12 flex">
      <button pButton label="GeneTitan Loaded" (click)="completeGeneTitanLoaded()" 
        class="buttonsRound multi_UpdateButton VioletButtons" [disabled]="multiUpdateBeadChipInfoList.length == 0">
      </button>
    </div>
  </div>
</p-dialog>
<p-dialog header="Array Loading Confirmation" [(visible)]="arrayLoadingConfirmationPopupVisible" position="top" [modal]="true" [style]="{'width':'50vw'}" [contentStyle]="{'max-height':'70vh'}" (onHide)="arrayLoadingConfirmationPopupVisible = false">
  <div class="col-12">
    The following plates are getting loaded, please confirm the selection:
  </div>
  <div class="col-12">
    Array ID: <span class="font-bold">{{axiom384Beadchip}}</span>
  </div>
  <div class="col-12">
    <p-table [value]="axiom384Plates" [columns]="axiom384PlateTableColumns">
      <ng-template pTemplate="header" let-columns>
        <tr class="text-center border-none">
          <th scope="col" *ngFor="let col of columns" [style.width]="col.width" >{{col.header}}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body"  let-columns="columns" let-rowdata>
        <tr class="border-none">
          <td class="text-center" *ngFor="let col of columns" [style.width]="col.width" >{{rowdata[col.field]}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-footer>
  <div class="col-12 flex justify-content-between">
    <button pButton label="Cancel" (click)="arrayLoadingConfirmationPopupVisible = false" class="buttonsRound multi_UpdateButton stop-action-button"></button>
    <button pButton label="Confirm" (click)="loadBeadchipForAxiom384()" class="buttonsRound multi_UpdateButton startButton"></button>
  </div>
  </p-footer>
</p-dialog>